import React from 'react'
import styled from 'styled-components'

import { mediaQ, fontSizeResponsive } from '../theme/mixins'

const VideoBoxContainer = styled.video`
  background-image: url(${(props) => props.videoPlaceholder});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: ${(props) => (props.width ? props.width : '46.5625%')};
  height: ${(props) => (props.height ? props.height : '46.5740740741%')};
  align-self: center;
  position: absolute;
  right: ${(props) => (props.right ? props.right : '11.8%')};
  bottom: ${(props) => (props.bottom ? props.bottom : '26vh')};
  object-fit: ${(props) => (props.objFit ? props.objFit : 'unset')};

  cursor: pointer;

  ${mediaQ(
    'mobileAll',
    'height:80%;top:20%;width:100%;right:0;object-fit: cover;background:none;'
  )}

  &.live {
    ${mediaQ('mobileAll', 'height: unset;top:unset; object-fit: none;')}
  }

  &.small {
    ${mediaQ('mobileAll', 'height:50%;top:35%; width: 90%; left:5%')}
  }

  ${mediaQ('ipad12', 'height: unset;bottom: 38vh;')}
  ${mediaQ('ipad10', 'height: unset;bottom: 38vh;')}
  ${mediaQ('ipad9', 'height: unset;bottom: 38vh;')}
`

const VideoBox = ({
  source,
  onclick,
  boxSize,
  autoplay,
  width,
  height,
  right,
  bottom,
  objFit,
  poster,
}) => {
  return (
    <VideoBoxContainer
      bottom={bottom}
      right={right}
      height={height}
      width={width}
      autoPlay={autoplay}
      onClick={onclick}
      className={boxSize}
      objFit={objFit}
    >
      <source autoplay src={source} type="video/mp4" />
    </VideoBoxContainer>
  )
}

export default VideoBox
